export interface User {
  roleType: ROLE;
  lob: string;
  country: string;
  groupSalesAuthority: Authority;
  groupUnderwriterAuthority: Authority;
  uuid: string;
  profileId: string;
  groupId: string;
}

export interface Authority {
  registration: {
    actions: {
      Inquire: boolean;
    };
  };
  proposal: {
    actions: {
      Inquire: boolean;
      Add: boolean;
      Delete: boolean;
      Edit: boolean;
      AddVersion: boolean;
    };
    confirmRole: {
      assessor: boolean;
      approver: boolean;
    };
  };
  task: {
    actions: {
      Inquire: boolean;
    };
    sanctions: TaskSanction[];
  };
}

export interface TaskSanction {
  taskType: string;
  riskScoringStatus?: string[];
}

export enum ROLE {
  SALE = 'N_GS',
  UW = 'N_GU',
  EMPLOYEE = 'N_ME',
  EMPLOYER = 'N_HR',
}

export enum PERMISSION {
  INQUIRE_TASK = 'task.actions.Inquire',
  INQUIRE_REGISTRATION = 'registration.actions.Inquire',
  INQUIRE_PROPOSAL = 'proposal.actions.Inquire',
  ADD_PROPOSAL = 'proposal.actions.Add',
  DELETE_PROPOSAL = 'proposal.actions.Delete',
  EDIT_PROPOSAL = 'proposal.actions.Edit',
  ADD_VERSION_PROPOSAL = 'proposal.actions.AddVersion',
  ASSESSOR = 'proposal.confirmRole.assessor',
  APPROVER = 'proposal.confirmRole.approver',
}

export enum AuthorityKey {
  N_GS = 'groupSalesAuthority',
  N_GU = 'groupUnderwriterAuthority',
}
